import * as React from 'react';

import cx from 'classnames';

import { Divider } from '~shared/components/Divider';
import { IconDocument } from '~shared/components/icons/standard';

export interface ListItemQuizProps {
  onClick: (e?: React.MouseEvent<HTMLElement>) => void;
  name: string;
  type: 'quiz';
  uniqueId: string;
  isSelected?: boolean;
  isDisabled?: boolean;
}

export function QuizWorkspaceListItemQuiz({
  name,
  uniqueId,
  isDisabled,
  onClick,
  isSelected,
}: ListItemQuizProps) {
  const listClass = cx(
    'flex flex-row items-center justify-start py-4',
    !isDisabled ? 'cursor-pointer' : 'cursor-default'
  );

  const textClass = cx('pl-6 group text-base font-500 leading-8 w-full', {
    'text-blue-900 hover:text-cyan-700 truncate': !isDisabled,
    'text-grey-800 hover:text-grey-800': isDisabled,
  });

  const iconClass = cx('flex items-center justify-start min-w-6 text-grey-800');

  return (
    <>
      <li
        className={listClass}
        onClick={isDisabled ? () => {} : onClick}
        key={uniqueId}
      >
        <div className={iconClass}>
          <IconDocument />
        </div>
        <span className={textClass}>
          {name} {__DEV__ ? (isSelected ? '✅' : null) : null}
        </span>
      </li>
      <Divider />
    </>
  );
}
